import { render, staticRenderFns } from "./OtherFilesModal.vue?vue&type=template&id=820998c8&"
import script from "./OtherFilesModal.vue?vue&type=script&lang=js&"
export * from "./OtherFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./OtherFilesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports